module.exports = __webpack_public_path__ + "static/media/kr_background.d1ab7175.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/kr_background.png
// module id = 2569
// module chunks = 0